<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'115px'" :get-action="queryApi" :serial="serial" :before-query-search="beforeQuerySearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <!-- 客户名称 -->
         <el-col v-if="!$store.getters.cusId" :span="colSpan">
             <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
              <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
            </el-form-item>
        </el-col>
         <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessBatchInventoryQuery.table.skuCode')" prop="skuCode">
                <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessBatchInventoryQuery.table.skuCode')" clearable @keyup.enter.native="handleQuery" />
           </el-form-item>
        </el-col>
        <!-- 批次号 -->
         <el-col :span="colSpan">
             <el-form-item :label="$t('BusinessPurchaseOrder2.form.batchCode')" prop="batchNum">
                <BjInput v-model="queryParams.batchNum" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessPurchaseOrder2.form.batchCode')" clearable @keyup.enter.native="handleQuery" />
             </el-form-item>
         </el-col> 
            <!-- 订单号 -->
         <el-col :span="colSpan">
              <el-form-item :label="$t('BjDialogListConfig.orderNo')" prop="outerOrderNo">
                <BjInput v-model="queryParams.outerOrderNo" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BjDialogListConfig.orderNo')" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
         </el-col>
         <el-col :span="colSpan">
            <el-form-item :label="$t('RoleManagement.common.Status')" prop="status">
              <BjSelectLov v-model="queryParams.status" :clearable="false" :option-list="STATUS_LIST" :placeholder="$t('RoleManagement.common.Status')" />
            </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
              <span v-else-if="col.prop === 'stockNum'">{{ (scope.row.stockNum).toFixed(0) }}</span>
              <span v-else-if="col.prop === 'preemptionNum'">{{ (scope.row.preemptionNum + scope.row.lockNum).toFixed(0) }}</span>
              <span v-else>{{ scope.row[col.prop] | timeFilters }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" align="center">
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
const getDefaultForm = () => {
  return {};
};

export default {
  name: 'BusinessBatchInventoryQuery',
  mixins: [pageMiXin],
  data() {
    return {
      queryApi: orderApi.getThirdItemBatchPage,
      colSpan: 4,
      // 查询参数
      queryParams: {
        outerOrderNo:null,
        cusId: this.$store.getters.cusId || null,
        skuCode:null,
        batchNum:null,
        status: null,
      },
      STATUS_LIST: [
        { value: 'New', label: 'New' },
        { value: 'Lock', label: 'Lock' },
        { value: 'Cancel', label: 'Cancel' },
        { value: 'Done', label: 'Done' },
      ],
      // 表单参数
      form: getDefaultForm(),
      // 表单校验
      rules: {},
      labelsVersion: 11,
      labelList1: [
          { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false },
          { label: 'BusinessBatchInventoryQuery.table.skuCode', prop: 'standardSkuCode', isCheck: true, disabled: false },
          { label: 'BjDialogListConfig.orderNo', prop: 'webReference', isCheck: true, disabled: false },
          { label: 'billingPage.quantity', prop: 'quantity', isCheck: true, disabled: false },
          { label: 'BusinessPurchaseOrder2.form.batchCode', prop: 'batchNum', isCheck: true, disabled: false},
          { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false},
      ],
      labelList2: [
          { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false },
          { label: 'billingPage.CustomerName', prop: 'cusId', isCheck: true, disabled: false },
          { label: 'BusinessBatchInventoryQuery.table.skuCode', prop: 'standardSkuCode', isCheck: true, disabled: false },
          { label: 'BjDialogListConfig.orderNo', prop: 'webReference', isCheck: true, disabled: false },
          { label: 'billingPage.quantity', prop: 'quantity', isCheck: true, disabled: false },
          { label: 'BusinessPurchaseOrder2.form.batchCode', prop: 'batchNum', isCheck: true, disabled: false},
          { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false},
      ],
    };
  },
  computed: {
    labelList() {
      if (this.$store.getters.cusId) {
        return this.labelList1;
      } else {
        return this.labelList2;
      }
    },
  },
};
</script>
<style scoped>
::v-deep .bj-page .el-form-item__label {
  display: none;
}
</style>
